module.exports = __webpack_public_path__ + "img/water.de1fb76c.png";